<template>
    <a href="#" @click.prevent.stop="click" title="Ostukorv">
        <b-icon-cart2></b-icon-cart2><span class="badge badge-info">{{count}}</span>
    </a>
</template>

<script>

    import {BIconCart2} from 'bootstrap-vue';

    export default {
        name: "CartButton",
        components: {
            'b-icon-cart2': BIconCart2,
        },
        methods: {
            click: function(){
                this.$emit('click');
            },
        },
        computed: {
            count: function(){
                return this.$store.getters['cart/getCount'];
            },
        },
    }

</script>

<style scoped>

</style>